var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splashscreen"},[_c('div',{staticClass:"splashscreen-wrapper"},[_c('span',{staticClass:"splashscreen-text"},[_vm._v(" "+_vm._s(_vm.$t('ui.dataLoading'))+"… ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }